// import amber from "@mui/material/colors/amber";
import green from "@mui/material/colors/orange";
import { createTheme } from "@mui/material/styles";

export default createTheme({
  palette: {
    primary: {
      ///hausify blau 00a2c7
      main: "#677391",
    },
    secondary: {
      ///hausify orange FCC332 (zb Head-Zeile Dropdown)
      // light
      // dark
      main: "#CC1E1C",
      contrastText: "#fff",
    },
    background: {
      default: "#f5f5f5",
    },
    notification: {
      ticketBadge: {
        // The number configures the shade
        main: green[500],
        text: "#fff",
      },
    },
    importNotification: {
      main: "#677391",
      text: "#fff",
    },
    ticketsNotification: {
      ///hausify orange FCC332 (zb Meine Verwaltung)
      main: "#787378",
      text: "#fff",
    },
    estateNotification: {
      ///hausify rosa e3cfde
      main: "#e3cfde",
      contrastText: "#333",
    },
    postingsNotification: {
      ///hausify blau 00a2c7
      main: "#CC1E1C",
      text: "#fff",
    },

    documentsNotification: {
      main: "#eee",
      contrastText: "#333333",
      text: "#333333",
    },
    explainerBox: {
      main: "#777",
    },
  },
  typography: {
    fontFamily: ["roboto", "sans-serif", "serif"].join(","),
  },
});
